<template>
  <div class="avue-tags">
    <!-- tag盒子 -->
    <div
        v-if="contextmenuFlag"
        class="avue-tags__contentmenu"
        :style="{ left: contentmenuX + 'px', top: contentmenuY + 'px' }"
    >
      <!--      <div class="item" @click="clearCacheTags">清除缓存</div>-->
      <!--      <div class="item" @click="closeOthersTags">关闭其他</div>-->
      <div class="item" @click="closeAllTags">关闭所有</div>
    </div>
    <!--    <div class="avue-tags__box" :class="{ 'avue-tags__box&#45;&#45;close': !false }">-->
    <!--    :closable="tagLen !== 1"-->
    <div class="avue-tags__box">
      <el-tabs
          v-model="active"
          type="card"
          @contextmenu.native="handleContextmenu"
          :closable="true"
          @tab-click="isCloseTip"
          @edit="menuTag"
      >
        <el-tab-pane
            :key="item.fullPath"
            v-for="item in tagList"
            :label="item.name"
            :name="item.fullPath"
        >
        </el-tab-pane>
      </el-tabs>
      <!--      <el-dropdown class="avue-tags__menu">-->
      <!--        <el-button type="primary" size="small">-->
      <!--          更多-->
      <!--          <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
      <!--        </el-button>-->
      <!--        <el-dropdown-menu slot="dropdown">-->
      <!--          <el-dropdown-item @click="$router.push('./')">退出登陆</el-dropdown-item>-->
      <!--          <el-dropdown-item @click.native="closeOthersTags"-->
      <!--            >222</el-dropdown-item-->
      <!--          >-->
      <!--          <el-dropdown-item @click.native="closeAllTags">333</el-dropdown-item>-->
      <!--          <el-dropdown-item @click.native="clearCacheTags"-->
      <!--            >444</el-dropdown-item-->
      <!--          >-->
      <!--        </el-dropdown-menu>-->
      <!--      </el-dropdown>-->
    </div>
  </div>
</template>
<script>
import {getStore} from "@/util/store";
import {mapGetters, mapState} from "vuex";
import Logo from "@/views/Layout/logo";
import {MessageBox} from "element-ui";
import store from "@/store";

export default {
  name: "tagS",
  data() {
    return {
      theLabel: '',
      fullscreenLoading: false,
      active: "",
      contentmenuX: "",
      contentmenuY: "",
      contextmenuFlag: false,
      info: {},
    };
  },
  created() {
    window.sessionStorage.removeItem("draftForm");
  },

  mounted() {
    this.setActive();
  },
  watch: {
    tag() {
      this.setActive();
    },
    contextmenuFlag() {
      window.addEventListener("mousedown", this.watchContextmenu);
    },
  },
  computed: {
    ...mapGetters(["tagWel", "tagList", "tag"]),
    ...mapState({
      showTag: (state) => state.common.showTag,
    }),
    tagLen() {
      return this.tagList.length || 0;
    },

  },

  methods: {
    generateTitle(item) {
      return this.$router.$avueRouter.generateTitle(
        item.label,
        (item.meta || {}).i18n
      );
    },
    watchContextmenu(event) {
      if (!this.$el.contains(event.target) || event.button !== 0) {
        this.contextmenuFlag = false;
      }
      window.removeEventListener("mousedown", this.watchContextmenu);
    },
    handleContextmenu(event) {
      let target = event.target;
      // 解决 https://github.com/d2-projects/d2-admin/issues/54
      let flag = false;
      if (target.className.indexOf("el-tabs__item") > -1) flag = true;
      else if (target.parentNode.className.indexOf("el-tabs__item") > -1) {
        target = target.parentNode;
        flag = true;
      }
      if (flag) {
        event.preventDefault();
        event.stopPropagation();
        this.contentmenuX = event.clientX;
        this.contentmenuY = event.clientY;
        this.tagName = target.getAttribute("aria-controls").slice(5);
        this.contextmenuFlag = true;
      }
    },
    //激活当前选项
    setActive() {
      this.active = this.tag.fullPath;
    },
    // 点击删除 删除TAG标签
    menuTag(value) {
      if (this.$store.state.user.isCloseTip) {
        MessageBox.confirm("请注意确认暂存？", "提示", {
          confirmButtonText: "直接跳转",
          cancelButtonText: "返回暂存",
          type: "warning",
          closeOnClickModal: false,
        }).then(() => {
          this.$store.state.user.isCloseTip = false
          this.jump(value)
        })

      } else {
        this.jump(value)
      }


    },
    jump(value) {
      let list = getStore({name: "tagList"});
      if (list.length == '0') {
        this.$store.commit("SET_TAGLIST", list);
        this.$router.push("/wel/index");
        return
      }
      for (let i in list) {
        if (list[i].fullPath == value) {

          list.splice(i, 1);
          this.$store.commit("SET_TAGLIST", list);
          if (i == 0) {
            this.active = "/wel/index";
            this.$router.push("/wel/index");
          } else {
            this.active = list[i - 1].path;
            this.$router.push(list[i - 1].fullPath || list[i - 1].path);
          }

          return;
        }
      }
    },
    isCloseTip(item) {
      this.openTag(item)
    },
    openTag(item) {
      this.fullscreenLoading = true
      setTimeout(() => {
        this.$nextTick(() => {
          this.fullscreenLoading = false
        })
      }, 1000)
      this.$router.push(item.name);
    },

    closeOthersTags() {
      this.contextmenuFlag = false;
      let list = [...this.tag];
      if (this.tag.value == "/wel") list = [];

      this.$store.commit("SET_TAGLIST", list);
    },
    findTag(value) {
      let tag, key;
      this.tagList.map((item, index) => {
        if (item.value === value) {
          tag = item;
          key = index;
        }
      });
      return { tag: tag, key: key };
    },
    closeAllTags() {
      this.$store.state.user.isCloseTip = false
      let list = [];
      this.active = "/wel";
      this.contextmenuFlag = false
      this.$store.commit("SET_TAGLIST", list);
      this.$router.push("/wel");
    },
    clearCacheTags() {
      this.$confirm("是否需要清除缓存?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {});
    },
  },
};
</script>


